module.exports = __webpack_public_path__ + "static/berserker_axe-08b047bd879e5603b8d3a45362b3528c.jpeg";